import React, { useState, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import RowMerakiLicence from "./RowMerakiLicence";
import { MerakiLicenceColumn } from "../../components/headerContent";
import Table from "../../components/Table";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { MerakiLicencePerDeviceColumn } from "../../components/headerContent";
import Loader from "../../components/Loader";
import { convertDateAndReturn } from "../../scripts/utils";
import NumberCard from "../../components/Card/NumberCard";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function MerakiLicences() {
    const { apiUrl } = useContext(AuthContext);
    const [differencesLicences, setDifferencesLicences] = useState(false);
    const { t } = useTranslation();

    function calculateRemainingDays(startDate, duration) {
        let today = new Date()
        let startDateObj = new Date(startDate);
        let endDateObj = startDateObj.setDate(startDateObj.getDate() + duration);
        const expirationDate = convertDateAndReturn(endDateObj);

        return expirationDate;
    }


    const getLicencesSub = async () => {
        const res = await axios.get(`${apiUrl}meraki/licenses_global`, {
            withCredentials: true
        })
        return !res.data.includes("No data") ? res.data.map(item => {
            return {
                ...item,
                expiration: !item.expired ? calculateRemainingDays(item.startedAt, item.duration) : null
            }
        }) : res.data
    }

    const licencesSub = useQuery({
        queryKey: ["merakiLicencesSub"],
        queryFn: getLicencesSub
    })

    const getLicencesPerDevices = async () => {
        const res = await axios.get(`${apiUrl}meraki/licenses_per_devices`, {
            withCredentials: true
        })
        return !res.data.includes("No data") ? res.data.map(item => {
            return {
                ...item,
                expiration: !item.expired ? calculateRemainingDays(item.startedAt, item.duration) : null
            }
        }) : res.data
    }

    const licencePerDevices = useQuery({
        queryKey: ["licencesPerDevices"],
        queryFn: getLicencesPerDevices
    })

    const handleClickDifferenceLicence = state => {
        if (state === true) {
            setDifferencesLicences(true);
        } else {
            setDifferencesLicences(false);
        }
    };

    if (licencesSub.isError && licencePerDevices.isError || licencesSub.data && licencesSub.data.includes("No data") && licencePerDevices.data && licencePerDevices.data.includes("No data")) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Aucun équipement Meraki disponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                {!licencesSub.isLoading && !licencePerDevices.isLoading ? (
                    <>
                        <div className="ecp-container-content-header">
                            <div className="ecp-container-content-header-title">
                                <div className="page-title page-logo">
                                    <h1 className="page-title">{t('Licences')}</h1>
                                </div>
                            </div>
                            <Link to={"/meraki"} className="buttons-ecp buttons-ecp-new"> <FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
                        </div>
                        <section className="page-section">
                            {licencesSub.data !== undefined && licencePerDevices.data !== undefined ? (
                                <NumberCard
                                    title="Licences disponibles"
                                    number={licencesSub.data.length + licencePerDevices.data.length}
                                    logo={faCircleCheck}
                                    color={"#AEC353"}
                                    stylesIcons={"logo-certificats"}
                                />
                            ) : licencesSub.data !== undefined && licencePerDevices.data === undefined ? (
                                <NumberCard
                                    title="Licences disponibles"
                                    number={licencesSub.data.length}
                                    logo={faCircleCheck}
                                    color={"#AEC353"}
                                    stylesIcons={"logo-certificats"}
                                />
                            ) : (
                                <NumberCard
                                    title="Licences disponibles"
                                    number={licencePerDevices.data.length}
                                    logo={faCircleCheck}
                                    color={"#AEC353"}
                                    stylesIcons={"logo-certificats"}
                                />
                            )}
                        </section>
                        <div className="page-title return-link-meraki">
                            {licencesSub.data !== undefined && licencePerDevices.data !== undefined &&
                                <div className="differences-licenses">
                                    <div onClick={() => { handleClickDifferenceLicence(false) }} id="licence-global" className={`licence-types ${!differencesLicences ? "licence-current" : ""}`}>
                                        <h2>GLobal</h2>
                                    </div>
                                    <div onClick={() => { handleClickDifferenceLicence(true) }} id="licence-per-device" className={`licence-types ${differencesLicences ? "licence-current" : ""}`}>
                                        <h2>{t(`Per devices`)}</h2>
                                    </div>
                                </div>
                            }
                        </div>
                        {licencesSub.data !== undefined && licencePerDevices && licencePerDevices.data !== undefined ? (
                            <div className="table-meraki-licences">
                                {!differencesLicences ? (
                                    <Table
                                        tableColumns={MerakiLicenceColumn}
                                        rowComponent={RowMerakiLicence}
                                        tableData={licencesSub.data}
                                    />
                                ) : (
                                    <Table
                                        tableColumns={MerakiLicencePerDeviceColumn}
                                        tableData={licencePerDevices.data}
                                    />
                                )}
                            </div>
                        ) : licencesSub.data !== undefined && licencePerDevices.data === undefined ? (
                            <Table
                                tableColumns={MerakiLicenceColumn}
                                rowComponent={RowMerakiLicence}
                                tableData={licencesSub.data}
                            />
                        ) : (
                            <Table
                                tableColumns={MerakiLicencePerDeviceColumn}
                                tableData={licencePerDevices.data}
                            />
                        )}
                    </>
                ) : <Loader />}
            </div>
        </div>
    )
}